import { tw } from "@careinfo/tailwind";
import ACCOUNTS from "../../../../constant/Accounts";
import APIS from "../../../../constant/Endpoint";
import ComboboxInput from "../../../Reusable/ComboboxInput";
import FormDatePicker from "../../../Reusable/DateField";
import FileUpload from "../../../Reusable/FileUpload";
import NpDatePicker from "../../../Reusable/NepaliDatePicker";
import NumberField from "../../../Reusable/NumberField";
import TextAreaField from "../../../Reusable/TextAreaField";
import TextField from "../../../Reusable/TextField";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    watch,
    isDraft = true,
    setOpenAccountPopup,
    isEdit,
    setpartypopup,
  } = props;
  return (
    <>
      <div className={tw`grid grid-cols-3  gap-x-4 px-4`}>
        {isEdit ? (
          <TextField
            label="Voucher Number"
            control={control}
            name={"seq_no"}
            placeholder="Enter Sequence Number"
            disabled={true}
          />
        ) : (
          <TextField
            label="Voucher Number"
            control={control}
            name={"number_series"}
            placeholder="Enter Number Series"
            disabled={true}
          />
        )}

        <NpDatePicker
          label="Miti"
          name="voucher_date"
          disableFuture={true}
          disabled={!isDraft}
          value={watch("voucher_date")}
          setValue={setValue}
          error={errors?.voucher_date}
        />

        <FormDatePicker
          label="Date"
          name="voucher_date"
          disabled={!isDraft}
          control={control}
        />
      </div>
      <div className={tw` grid grid-cols-2 gap-x-4 px-4`}>
        <div
          className={tw`w-full flex items-start mt-2  justify-center space-x-1`}
        >
          <ComboboxInput
            url={APIS.COA}
            queryKey={"cash-account"}
            register={register("account")}
            errors={errors?.account}
            name={"account"}
            label={"Cash Account"}
            setValue={setValue}
            disabled={!isDraft}
            props={{
              parent: ACCOUNTS.CASH_ID,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setOpenAccountPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
        <NumberField
          value={getValues("amount")}
          register={register("amount")}
          errors={errors?.amount}
          label={"Amount"}
          setValue={setValue}
          disabled={!isDraft}
          delimiter=","
          clearErrors={clearErrors}
        />

        <div
          className={tw`w-full flex items-start mt-2 justify-center space-x-1`}
        >
          <ComboboxInput
            url={APIS.COA}
            queryKey={"account"}
            register={register("party_account")}
            errors={errors?.party_account}
            name={"party_account"}
            label={"Ledger Account"}
            setValue={setValue}
            props={{
              is_group: false,
              children__isnull: true,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
            disabled={!isDraft}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setpartypopup((prev) => !prev)}
          >
            +
          </button>
        </div>
        <div className={tw`mt-2`}>
          <TextField
            label="Reference Number"
            control={control}
            disabled={!isDraft}
            name={"reference_number"}
          />
        </div>
        <div className={tw`mt-2`}>
          <NpDatePicker
            label="Reference Date"
            name="reference_date"
            disabled={!isDraft}
            value={watch("reference_date")}
            setValue={setValue}
            disableFuture={true}
            error={errors?.reference_date}
          />
        </div>
        <div></div>
        <FileUpload
          label="Attachment"
          register={register("attachment")}
          watch={watch}
          errors={errors}
          setValue={setValue}
          disabled={!isDraft}
        />
        <TextAreaField
          label="Narration"
          control={control}
          name={"narration"}
          disabled={!isDraft}
          placeholder="Write notes here..."
        />
      </div>
    </>
  );
};

export default Form;

